module.exports = __webpack_public_path__ + "assets/img/vue_template_colon.904d30d0.jpg";